const cache = new Map<string, Intl.DisplayNames>()

function getDisplayNames(locale: string): Intl.DisplayNames {
  if (!cache.has(locale)) {
    cache.set(locale, new Intl.DisplayNames([locale], { type: 'region' }))
  }
  return cache.get(locale)!
}

export function getCountryDisplayName(
  countryCode: string,
  locale: string,
): string {
  try {
    return getDisplayNames(locale).of(countryCode) ?? countryCode
  } catch {
    return countryCode
  }
}
